export default defineNuxtPlugin((nuxtApp) => {
    // 保存原始的 console.log 方法
    const originalLog = console.log;
    console.log = (function (oldLogFunc) {
        return function (...args) {
            if (process.env.NODE_ENV === 'development') {
                // 明确 this 指向 console，执行原始的 console.log 功能
                oldLogFunc.apply(console, args);
            } else {
                // 在非开发环境下，定义为空函数，相当于禁用 console.log
                return;
            }
        };
    })(originalLog);
    return {
        provide: {
            // 可以选择将重写后的 console.log 暴露出去，方便其他地方获取（可选操作）
            customLog: console.log
        }
    };
});